module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/DejaVuSans-Bold-print-cea438409c2d5293b9223a61e66923da.ttf";